import { render, staticRenderFns } from "./activityLive.vue?vue&type=template&id=a0920480&scoped=true"
import script from "./activityLive.vue?vue&type=script&lang=js"
export * from "./activityLive.vue?vue&type=script&lang=js"
import style0 from "./activityLive.vue?vue&type=style&index=0&id=a0920480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0920480",
  null
  
)

export default component.exports